import { render, staticRenderFns } from "./posterManagementModal.vue?vue&type=template&id=5c031974&scoped=true"
import script from "./posterManagementModal.vue?vue&type=script&lang=js"
export * from "./posterManagementModal.vue?vue&type=script&lang=js"
import style0 from "./posterManagementModal.vue?vue&type=style&index=0&id=5c031974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c031974",
  null
  
)

export default component.exports